import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    ariaLabelForAccountMenu: string;
    accountSwitcherTooltip: string;
    unsupportedAccounts: string;
    unsupportedAccountsDescription: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** ARIA label for the list of selectable accounts in the account switcher menu */
            ariaLabelForAccountMenu: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AccountSwitcherList.ariaLabelForAccountMenu?c=1iiphdurg0gik", defaultMessage: "Account Option Menu" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Tooltip label for the primary-nav account switcher button */
            accountSwitcherTooltip: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AccountSwitcherList.accountSwitcherTooltip?c=1sovhp652js1f", defaultMessage: "Switch Accounts" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Section header shown above accounts that are not supported in this client */
            unsupportedAccounts: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AccountSwitcherList.unsupportedAccounts?c=3am0e0r7h6p82", defaultMessage: "Unsupported Accounts" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Helper text explaining how to access unsupported accounts from the legacy app/extension menu */
            unsupportedAccountsDescription: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AccountSwitcherList.unsupportedAccountsDescription?c=18ikahscikycu", defaultMessage: "Go to Window '>' Frame.io '>' Frame.io (Legacy) to access the following accounts." }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
